import { Box } from "@mui/material";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const DashboardLayout = ({ children }) => {
  return (
    <Box className="flex bg-gray-100 min-h-screen">
      <Sidebar />

      <Box className="flex-1 flex flex-col">
        <Topbar />
        <Box className="p-6">{children}</Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
